import { render, staticRenderFns } from "./BaseIconButtonPictureAsPdf.vue?vue&type=template&id=617703da&scoped=true&"
import script from "./BaseIconButtonPictureAsPdf.vue?vue&type=script&lang=js&"
export * from "./BaseIconButtonPictureAsPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617703da",
  null
  
)

export default component.exports